<ng-container *ngIf="member; else skeleton">
  <div class="d-flex flex-row align-items-center gap-3">
    <div>
      <div
        class="initials"
        [ngClass]="size"
        [style.background-color]="getBackgroundFromInitials()"
      >
        {{ member.initials() }}
      </div>
    </div>
    <div>
      <span class="fullname" [ngClass]="size"
        >{{ member.lastname }} {{ member.firstname }}</span
      ><br />
      <span class="fw-normal small text-muted">
        <app-copy [value]="member.id" [label]="'adh. n°'"></app-copy>
        <ng-container
          *ngIf="
            showEmail &&
            member.mail &&
            member.mail !== 'Non disponible' &&
            env.config?.memberDetails?.showEmails
          "
        >
          • {{ member.mail }}</ng-container
        >
      </span>
    </div>
  </div>
</ng-container>
<ng-template #skeleton>
  <ion-skeleton-text style="width: 100px; height: 25px"></ion-skeleton-text>
</ng-template>
